export default "__VITE_ASSET__cRszcOHk__"